import { useTranslation } from "react-i18next";
import TabsMobile from "../__template/TabsMobileComponent";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { credentialCheck } from "../../core/service/api";
import Config from "../../config/Config";
import User from "../../core/models/user";
import { useAppSelector } from "../../core/feature/hooks";
import userIcon from "../../assets/images/icon_profile/user.svg";
import { isDarkColor } from "../../config/DarkColorChecker";
import CustomApp from "../../core/models/customApp";

export const RecitationSubmissionWeb = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isToken, setIsToken] = useState<any>(false);
  const [dataUser, setDataUser] = useState([]);

  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  const env = Config.BaseUrlDev;
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    try {
      if (location.pathname.split("/")[2] != undefined) {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
        });
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
        }
      }
    } catch (error) {}
  }, [location.pathname.split("/")[2]]);

  function getData() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")));
    temp = temp.accounts[0].callerIdentities;
    console.log(temp);
    setDataUser(temp);
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }
  return (
    <>
      <div className="relative min-h-screen h-full z-50 bg-psp-primary pb-10">
        <div className="bg-psp-primary px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("ACCOUNT.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
          <section className="mt-1 flex flex-col gap-3">
            {dataUser.map((item: any, index: number) => {
              return (
                <div
                  className="flex flex-row z-10 h-24 bg-white w-full rounded-3xl"
                  key={index}
                >
                  <div className="relative w-20 h-20 bg-gray-200 my-auto rounded-xl ml-3">
                    {item.photoUrl && (
                      <img
                        src={getImgContent(item.photoUrl)}
                        alt=""
                        className="relative w-20 object-cover h-20"
                      />
                    )}
                    {!item.photoUrl && (
                      <img
                        src={userIcon}
                        alt=""
                        className="w-20 p-1 object-cover h-20"
                      />
                    )}
                  </div>
                  <div className="flex flex-row justify-between w-full">
                    <div className="flex flex-col px-3 justify-center">
                      <h1
                        className={`font-montserrat m-0 font-medium text-sm ${
                          item.active ? "text-black" : "text-gray-500"
                        }`}
                      >
                        {item.name.length > 15
                          ? item.name.slice(0, 16) + "..."
                          : item.name}
                      </h1>
                      <h1
                        style={{ fontSize: 11 }}
                        className={`font-montserrat m-0 font-normal ${
                          item.active ? "text-black" : "text-gray-500"
                        }`}
                      >
                        {item.title}: {item.callerId}
                      </h1>
                    </div>
                    <div className="my-auto mr-3">
                      <button
                        className="bg-psp-btn-primary py-2 px-4 rounded-lg  text-white font-bold text-xs"
                        onClick={() =>
                          navigate("/setoran-hafalan/report", {
                            state: {
                              data: item,
                            },
                          })
                        }
                      >
                        Detail
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      </div>
    </>
  );
};
